import { Injectable } from '@angular/core';
interface Scripts {
  name: string;
  src: string;
 id: string;
}
export const ScriptStore: Scripts[] = [
  { name: 'wayForPayWidget', id:"wayForPayWidgetScript", src: 'https://secure.wayforpay.com/server/pay-widget.js' },
];

@Injectable({
  providedIn: 'root'
})
export class ScriptsService {

  private scripts: any = {};

  constructor() {
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src,
	id: script.id
      };
    });
  }

  load(...scripts: string[]) {
    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      // resolve if already loaded
      if (this.scripts[name].loaded) {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      } else {
        // load script
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        script.id = this.scripts[name].id
        script.onload = () => {
          this.scripts[name].loaded = true;
          resolve({ script: name, loaded: true, status: 'Loaded' });
        };
        script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }


  unloadScript(name: string){
	
	if(this.scripts[name].loaded){
		document.getElementById(this.scripts[name].id).remove()
		this.scripts[name].loaded = false
	}

  }

  
}
